import Vue from "vue";
import jwtDecode from "jwt-decode";

export const listRoles = {
  solicitudes: Object.freeze({
    lista: "ROLE_SOLICITUD_LISTAR",
    crear: "ROLE_SOLICITUD_CREAR",
    editar: "ROLE_SOLICITUD_EDITAR",
    ver: "ROLE_SOLICITUD_VER",
    enviar_aprobar: "ROLE_SOLICITUD_ENVIAR_APROBACION",

    jefatura_lista_aprobar: "ROLE_SOLICITUD_JEFATURA_APROBACION_LISTAR",
    rrhh_lista_aprobar: "ROLE_SOLICITUD_RRHH_APROBACION_LISTAR",
    ufi_lista_aprobar: "ROLE_SOLICITUD_UFI_APROBACION_LISTAR",
    despacho_lista_aprobar: "ROLE_SOLICITUD_DESPACHO_APROBACION_LISTAR",
    dinarh_lista_aprobar: "ROLE_SOLICITUD_DINARH_APROBACION_LISTAR",

    jefatura_evaluar: "ROLE_SOLICITUD_JEFATURA_EVALUAR",
    rrhh_evaluar: "ROLE_SOLICITUD_RRHH_EVALUAR",
    ufi_evaluar: "ROLE_SOLICITUD_UFI_EVALUAR",
    despacho_evaluar: "ROLE_SOLICITUD_DESPACHO_EVALUAR",
    dinarh_evaluar: "ROLE_SOLICITUD_DINARH_EVALUAR",

    evaluar: "ROLE_SOLICITUD_EVALUAR_ACTUALIZAR",

    eliminar: "DELETE_SOLICITUD",
    aprobar: "APROBAR_SOLICITUD",
  }),
  contrato: Object.freeze({
    listar: "ROLE_CONTRATACION_PROPUESTA_CANDIDATO_LISTAR",
    ver_candidato: "ROLE_CONTRATACION_PERSONA_PERFIL_VER",
    accion_ver_candidato: "ROLE_CONTRATACION_PERSONA_PERFIL_VER",
    accion_lista_acciones: "ROLE_CONTRATACION_LISTA_ACCIONES_CONTRATO",
  }),
  nombramiento: {
    lista: "ROLE_CONTRATACION_NOMBRAMIENTO_API_LISTAR",
    ver: "ROLE_CONTRATACION_NOMBRAMIENTO_VER",
    editar: "ROLE_CONTRATACION_NOMBRAMIENTO_ACTUALIZAR",
  },
  plantillas: {
    listar: "ROLE_CONTRATACION_PLANTILLA_DOCUMENTO_API_LISTAR",
    crear: "ROLE_CONTRATACION_PLANTILLA_DOCUMENTO_CREAR",
    ver: "ROLE_CONTRATACION_DOCUMENTO_PREVISUALIZAR_VER",
    editar: "ROLE_CONTRATACION_PLANTILLA_DOCUMENTO_ACTUALIZAR",
    duplicar: "ROLE_CONTRATACION_PLANTILLA_DOCUMENTO_DUPLICAR",
  },
  correlativos: {
    listar: "ROLE_CONTRATACION_PLANTILLA_CORRELATIVO_API_LISTAR",
    crear: "ROLE_CONTRATACION_PLANTILLA_CORRELATIVO_CREAR",
    ver: "ROLE_CONTRATACION_DOCUMENTO_PREVISUALIZAR_VER",
    editar: "ROLE_CONTRATACION_PLANTILLA_CORRELATIVO_ACTUALIZAR",
  },
  encabezados: {
    listar: "ROLE_CONTRATACION_PLANTILLA_DOCUMENTO_API_LISTAR",
    crear: "ROLE_CONTRATACION_PLANTILLA_DOCUMENTO_CREAR",
    ver: "ROLE_CONTRATACION_DOCUMENTO_PREVISUALIZAR_VER",
    editar: "ROLE_CONTRATACION_PLANTILLA_DOCUMENTO_ACTUALIZAR",
  },
  footer: {
    listar: "ROLE_CONTRATACION_PLANTILLA_DOCUMENTO_API_LISTAR",
    crear: "ROLE_CONTRATACION_PLANTILLA_DOCUMENTO_CREAR",
    ver: "ROLE_CONTRATACION_DOCUMENTO_PREVISUALIZAR_VER",
    editar: "ROLE_CONTRATACION_PLANTILLA_DOCUMENTO_ACTUALIZAR",
  },
  margenes: {
    listar: "ROLE_CONTRATACION_MARGENES_LISTAR",
    crear: "ROLE_CONTRATACION_MARGENES_CREAR",
    ver: "ROLE_CONTRATACION_MARGENES_VER",
    editar: "ROLE_CONTRATACION_MARGENES_ACTUALIZAR",
    // }
  },
};

Vue.prototype.listRoles = listRoles;

Vue.prototype.validRol = (rol) => {
  const safeJSONParse = (str) => {
    try {
      return JSON.parse(str);
    } catch {
      return null;
    }
  };

  const roles = safeJSONParse(localStorage.getItem("roles"));
  if (!Array.isArray(roles)) return false;
  return roles.includes(rol);
};
